export const ADD_DEGREE = 'ADD_DEGREE';
export const DELETE_DEGREE = 'DELETE_DEGREE';
export const ADD_MEMBER = "ADD_MEMBER";
